import React, { useEffect, useState } from "react";
import { Outlet, useLocation, useParams } from "react-router-dom";
import { useApiClient } from "../../contexts/ApiClientContext";
import ChemiNovaEntityType from "../../model/enums/ChemiNovaEntityType";
import PathInfo from "../../model/PathInfo";
import Site from "../../model/Site";
import APIEndPoints from "../../utils/APIEndPoints";
import PathDisplay from "../common/PathDisplay";
import Texture from "../../model/Texture";

/*
  Component to manage the entire SITES section
*/
function Textures() {
  // read the ID from the url
  const { id } = useParams();
  // store data path
  const [pathInfo, setPathInfo] = useState<PathInfo | undefined>(undefined);
  // reference to the ApiClient instance
  const apiClient = useApiClient();
  // reference to Location, to update path when it changes
  const location = useLocation();

  useEffect(() => {
    const getPathInfo = async () => {
      if (id) {
        const info = await apiClient?.get<Texture>({
          url: APIEndPoints.TEXTURES.ONE(parseInt(id)),
        });

        setPathInfo(
          new PathInfo(
            info.id!,
            info.name,
            ChemiNovaEntityType.TEXTURE_LAYER,
            info.parent,
            true
          )
        );
      } else {
        setPathInfo(undefined);
      }
    };
    getPathInfo();
  }, [location]);

  return (
    <div>
      <PathDisplay data={pathInfo!} />
      <Outlet />
    </div>
  );
}

export default Textures;
